export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '平台特色', href: '#features' },
  { label: '关于我们', href: '#about' },
  { label: '热门榜单', href: '#ranking' },
  { label: '最新动态', href: '#updates' },
  { label: '话题标签', href: '#topics' },
  { label: '专题合集', href: '#index' },
];

export const heroData = {
  tag: '🔥 全网热门漫画一网打尽',
  title: '新新漫画 · 高清漫画在线阅读首选平台',
  slogan: '每日更新，随时畅读，你的随身漫画图书馆',
  description: '新新漫画网是国内领先的高清漫画在线阅读平台入口，汇聚海量正版漫画资源，覆盖热血、恋爱、悬疑、奇幻、搞笑等全品类题材。平台每日同步更新最新话，提供流畅的跨设备阅读体验，无论电脑还是手机都能享受清晰细腻的画质呈现。新新漫画致力于为漫画爱好者打造安全、便捷、高品质的一站式阅读空间，让每一页漫画都跃然屏上。',
  stats: [
    { value: '12万+', label: '漫画资源' },
    { value: '每日更新', label: '更新频率' },
    { value: '高清画质', label: '阅读体验' },
  ],
  primaryCta: { label: '开始阅读', href: '#index' },
  secondaryCta: { label: '查看榜单', href: '#ranking' },
};

export const updatesData = [
  { date: '2026-07-28', title: '《星界传说》第 218 话更新 —— 终章序幕拉开，各方势力集结星界之巅', tag: '最新' },
  { date: '2026-07-27', title: '《暗夜追踪者》第三季正式上线，全新画风与剧情线引发读者热议', tag: '热门' },
  { date: '2026-07-26', title: '暑期阅读狂欢季开启，百部人气漫画限时免费开放阅读', tag: '活动' },
  { date: '2026-07-25', title: '新新漫画网页端阅读器全面升级，支持自适应滚动与夜间模式', tag: '功能' },
  { date: '2026-07-24', title: '《剑与玫瑰》作者独家专访：揭秘连载五年背后的创作故事', tag: '专访' },
  { date: '2026-07-23', title: '平台新增「书单分享」功能，一键创建专属漫画推荐清单', tag: '功能' },
  { date: '2026-07-22', title: '2026 年中人气投票结果公布，《苍穹之歌》蝉联最受欢迎作品', tag: '榜单' },
];

export const featuresData = [
  { icon: 'ri-hd-line', title: '高清画质', desc: '全站漫画均支持高清分辨率浏览，细节分毫毕现，每一格画面都如原稿般清晰锐利，带来沉浸式阅读享受。' },
  { icon: 'ri-flashlight-line', title: '极速更新', desc: '与多家漫画平台同步更新，热门作品章节上线后第一时间推送，追更不再等待，精彩永远快人一步。' },
  { icon: 'ri-stack-line', title: '海量资源', desc: '收录超过十二万部漫画作品，涵盖日漫、国漫、韩漫等多元类型，从经典名作到新锐佳作应有尽有。' },
  { icon: 'ri-device-line', title: '跨端畅读', desc: '完美适配电脑、平板与手机端，阅读进度云端同步，随时随地无缝衔接你的漫画旅程，离线缓存也安排上了。' },
];

export const contactData = {
  title: '联系我们',
  subtitle: '投稿 · 合作 · 反馈',
  desc: '欢迎漫画作者、汉化组及内容合作方联系我们。新新漫画为优质原创漫画提供展示平台，期待与更多创作者携手，共同打造更丰富的漫画阅读生态。读者如有任何建议或问题，也欢迎随时反馈。',
  email: 'contact@xinxincomics.com',
  qq: '漫画作者投稿群：888888888',
};

export const mediaData = [
  { title: '《星界传说》动画化预告 PV', desc: '万众期待的星界传说动画改编正式公开首支预告，恢弘的星界世界观首次以动画形式呈现。', tag: '动画PV', views: '128万' },
  { title: '漫画家的一天：专访《暗夜追踪者》作者', desc: '走进人气漫画家的工作室，揭秘从分镜到成稿的完整创作流程，听听那些不为人知的连载故事。', tag: '纪录片', views: '56万' },
  { title: '2026 夏季新番导览：这些漫画即将动画化', desc: '一口气盘点本季最值得期待的十部漫改动画新番，提前锁定你的追番清单。', tag: '盘点', views: '89万' },
  { title: '新新漫画书友线下见面会精彩回顾', desc: '上周末在北京举办的首届书友见面会圆满落幕，作者签绘、Cosplay、互动游戏燃爆全场。', tag: '活动', views: '42万' },
];

export const indexData = [
  { title: '热血战斗', desc: '燃到爆的战斗场面，不灭的斗志', count: '3.2万部', color: 'bg-primary-500' },
  { title: '恋爱甜宠', desc: '心动瞬间，甜蜜治愈你的每一天', count: '2.8万部', color: 'bg-accent-500' },
  { title: '悬疑推理', desc: '烧脑剧情，层层反转欲罢不能', count: '1.5万部', color: 'bg-secondary-500' },
  { title: '奇幻冒险', desc: '异世界大门已开，踏上奇妙旅程', count: '2.1万部', color: 'bg-primary-400' },
  { title: '搞笑日常', desc: '笑到停不下来，快乐就是这么简单', count: '1.9万部', color: 'bg-accent-400' },
  { title: '古风国漫', desc: '国风之美，水墨丹青间的动人故事', count: '1.2万部', color: 'bg-secondary-400' },
  { title: '科幻末世', desc: '未来世界，科技与人性的碰撞', count: '0.8万部', color: 'bg-primary-300' },
];

export const rankingData = [
  { rank: 1, title: '星界传说', author: '柳叶刀', genre: '奇幻冒险', heat: '9.8', change: 'up' },
  { rank: 2, title: '暗夜追踪者', author: '墨渊', genre: '悬疑推理', heat: '9.7', change: 'up' },
  { rank: 3, title: '苍穹之歌', author: '云中子', genre: '热血战斗', heat: '9.6', change: 'same' },
  { rank: 4, title: '剑与玫瑰', author: '花满楼', genre: '古风国漫', heat: '9.5', change: 'up' },
  { rank: 5, title: '次元裂缝', author: '极光', genre: '科幻末世', heat: '9.4', change: 'down' },
  { rank: 6, title: '甜梦制造局', author: '糖心', genre: '恋爱甜宠', heat: '9.3', change: 'new' },
];

export const aboutData = {
  title: '关于新新漫画',
  desc1: '新新漫画网成立于 2019 年，是国内领先的高清漫画在线阅读平台入口。平台始终坚持「内容为王、读者至上」的运营理念，致力于为漫画爱好者提供海量、高清、流畅的在线漫画阅读体验。经过多年深耕，新新漫画已积累了超过十二万部漫画作品资源，涵盖日漫、国漫、韩漫及欧美漫画等多元品类。',
  desc2: '我们与国内外多家知名漫画平台及出版社保持紧密合作，确保内容的正版性与更新及时性。同时，新新漫画积极扶持原创漫画创作，为新人作者提供展示舞台，推动中国漫画产业的繁荣发展。安全直达、无需跳转、高清画质——这就是新新漫画给你的承诺。',
};

export const cardsData = [
  { title: '《星界传说》', cover: '星界传说漫画封面，奇幻星空背景下的主角群像', tag: '奇幻冒险', desc: '少年林星河在机缘巧合下踏入星界，开启了一段横跨银河的传奇冒险。宏大世界观，细腻画风，不可错过的年度巨作。', update: '每周三更新' },
  { title: '《暗夜追踪者》', cover: '暗夜追踪者漫画封面，都市夜景中神秘侦探剪影', tag: '悬疑推理', desc: '退役刑警化身私家侦探，在都市暗影中追踪连环案件背后的真相。烧脑反转不断，每个细节都是线索。', update: '每周五更新' },
  { title: '《甜梦制造局》', cover: '甜梦制造局漫画封面，粉色梦幻氛围中的甜蜜情侣插画', tag: '恋爱甜宠', desc: '一个可以定制梦境的神秘店铺，一段命中注定的甜美邂逅。高甜预警，糖分超标，治愈你所有的疲惫。', update: '每周二更新' },
  { title: '《剑与玫瑰》', cover: '剑与玫瑰漫画封面，水墨风格古装剑客与花间少女', tag: '古风国漫', desc: '江湖纷争，侠骨柔情。一把断剑，一朵玫瑰，串联起两代人的恩怨情仇。国风美学巅峰之作。', update: '每周四更新' },
  { title: '《次元裂缝》', cover: '次元裂缝漫画封面，赛博朋克风格的未来都市与时空裂隙', tag: '科幻末世', desc: '2087 年，地球出现神秘次元裂缝，异界生物涌入。人类最后的希望，掌握在一群年轻的「裂隙行者」手中。', update: '每周六更新' },
  { title: '《苍穹之歌》', cover: '苍穹之歌漫画封面，天空之城与翱翔的龙骑士', tag: '热血战斗', desc: '天空之城「苍穹」面临覆灭危机，少年龙骑士们挺身而出。热血空战，伙伴羁绊，燃到每一根神经都在颤抖。', update: '每周一更新' },
];

export const topicsData = [
  { label: '日更连载', hot: true },
  { label: '新番推荐', hot: true },
  { label: '完结神作', hot: false },
  { label: '国漫崛起', hot: true },
  { label: '悬疑烧脑', hot: false },
  { label: '甜宠日常', hot: false },
  { label: '异世界', hot: true },
  { label: '战斗热血', hot: false },
  { label: '画风精美', hot: false },
  { label: '免费阅读', hot: true },
];

export const carouselData = [
  { title: '暑期追漫指南', subtitle: '这个夏天不容错过的 20 部漫画', desc: '从热血战斗到甜蜜恋爱，从烧脑悬疑到爆笑日常，我们为你精心挑选了今夏最值得追的漫画清单，每一部都是口碑与人气双丰收的佳作。', img: '夏日海滩风格漫画角色大集合插画，色彩明亮活泼，多位漫画角色在海边享受暑假', tag: '编辑精选' },
  { title: '新锐作者扶持计划', subtitle: '下一个漫画之星就是你', desc: '新新漫画原创扶持计划正式启动，面向全国征集优秀漫画作品。入选作者将获得全平台流量推荐、专业编辑指导以及稿费激励，让你的漫画梦想从这里起航。', img: '创作工作台场景，数位板、画笔与散落的漫画分镜稿，温暖的台灯光线下专注创作的手', tag: '原创扶持' },
  { title: '冷门佳作挖掘机', subtitle: '评分 9.0+ 却被埋没的神作', desc: '这些漫画没有铺天盖地的宣传，但每一部都拥有令人惊叹的故事和画工。我们翻遍了评分榜单，找出了十部被严重低估的冷门佳作，推荐给真正懂漫画的你。', img: '复古图书馆书架间的秘密藏书房场景，柔和光线透过彩色玻璃窗照在泛黄漫画书脊上', tag: '冷门推荐' },
  { title: '漫画改编影视大盘点', subtitle: '从纸页到大银幕的精彩蜕变', desc: '越来越多的优秀漫画被搬上大银幕和小荧幕。我们整理了近年来最成功的漫改影视作品，带你回顾那些让原著粉丝拍案叫绝的经典改编。', img: '电影院银幕与漫画书页融合的创意场景，胶片与漫画格子交织成梦幻视觉', tag: '影视改编' },
  { title: '每周漫评精选', subtitle: '专业编辑团队深度解读', desc: '每周末，新新漫画编辑团队精选本周最值得讨论的漫画章节，从叙事结构、画面表现到伏笔埋设，进行全方位的专业解读。深度漫评，让你的阅读体验再升一个维度。', img: '书房阅读角落，一杯热茶旁摊开的漫画书与写满笔记的便签，窗外是安静的夜色', tag: '深度漫评' },
];

export const appData = {
  title: '随时随地，畅享漫画',
  desc: '新新漫画移动客户端现已上线，支持 iOS 与 Android 双平台。高清画质、离线下载、夜间模式、阅读进度云同步 —— 你的口袋漫画图书馆，随时随地开启精彩阅读。',
  features: ['高清流畅阅读', '离线缓存下载', '夜间护眼模式', '跨设备进度同步'],
};

export const faqData = [
  { q: '新新漫画是否需要注册才能阅读？', a: '大部分漫画内容无需注册即可免费在线阅读。注册账号后可以享受书架收藏、阅读进度同步、书单分享等更多个性化功能，获得更完整的阅读体验。' },
  { q: '新新漫画的更新频率是怎样的？', a: '平台与多家合作方保持同步更新机制。热门连载漫画通常在原站更新后数小时内即可在新新漫画阅读到最新话，确保追更用户不错过任何精彩内容。' },
  { q: '漫画的画质如何？支持什么设备阅读？', a: '全站漫画均以高清分辨率呈现，支持电脑、平板、手机等多种设备访问。网页端采用自适应排版技术，在不同屏幕尺寸下都能获得舒适的阅读体验，并且支持夜间模式切换。' },
  { q: '新新漫画上的内容是否正版？', a: '新新漫画与国内外多家知名漫画平台及出版社建立了合作关系，平台上的内容均经过合法授权。我们始终坚持推动正版漫画阅读生态的建设与发展。' },
  { q: '如何向新新漫画投稿原创作品？', a: '欢迎漫画作者通过网站的联系方式或投稿渠道提交原创作品。我们的编辑团队会在收到投稿后的七个工作日内进行审阅并给出反馈，优秀作品将获得平台推荐位和稿费支持。' },
  { q: '遇到阅读问题或页面异常怎么办？', a: '如遇到页面加载异常、漫画无法正常显示等问题，建议先尝试刷新页面或清除浏览器缓存。若问题持续存在，可通过页面底部的联系方式反馈给我们，技术团队会尽快排查处理。' },
];

export const commentsData = [
  { name: '漫画迷小王', avatar: '王', rating: 5, text: '用了三年新新漫画了，画质一直很稳定，更新速度也快。最喜欢的是书架功能，追的几十部漫画都能统一管理，再也不用一个个网站去翻了。真心推荐给所有漫画爱好者！', date: '2026-07-25' },
  { name: '追番少女小樱', avatar: '樱', rating: 5, text: '偶然发现这个漫画平台入口，结果一发不可收拾。页面干净没有乱七八糟的广告，阅读体验比之前用的好几个漫画网站都好太多。夜间模式对睡前追漫党太友好了！', date: '2026-07-22' },
  { name: '二次元老司机', avatar: '司', rating: 4, text: '资源量确实大，很多冷门老漫画都能找到高清版本的。提个小建议希望手机端的翻页动画可以再流畅一些，其他方面都很满意。对了，最近上的书单分享功能挺有意思的。', date: '2026-07-18' },
  { name: '新入坑的阿杰', avatar: '杰', rating: 5, text: '朋友安利的新新漫画，说是最好用的免费漫画网站。用了一个月确实名不虚传，高清画质看着就是舒服。作为一个刚入坑的新人，首页的推荐和榜单帮了我大忙，已经追了十几部了！', date: '2026-07-15' },
];

export const footerData = {
  description: '新新漫画网 —— 高清漫画在线阅读首选平台入口。海量漫画资源，每日同步更新，安全直达，畅享阅读。这里是属于每一位漫画爱好者的精神角落。',
  quickLinks: [
    { label: '平台特色', href: '#features' },
    { label: '最新动态', href: '#updates' },
    { label: '热门榜单', href: '#ranking' },
    { label: '专题合集', href: '#index' },
    { label: '话题标签', href: '#topics' },
    { label: '关于我们', href: '#about' },
  ],
  supportLinks: [
    { label: '常见问答', href: '#faq' },
    { label: '联系我们', href: '#contact' },
    { label: '读者评论', href: '#comments' },
    { label: '移动客户端', href: '#app' },
  ],
  copyright: '© 2026 新新漫画 xinxincomics.com 版权所有',
};